import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import hero1 from "../assets/homehero1.jpg";
import hero2 from "../assets/homehero2.jpg";
import hero3 from "../assets/homehero3.jpg";
import stay from "../assets/home-section.jpg";
import CTASection from "../components/common/CTASection";
import {
  ChevronLeft,
  ChevronRight,
  Utensils,
  Home,
  Sparkles,
  HeartHandshake,
  Hotel,
  Building2,
  School,
  Heart,
  Landmark,
  Users
} from "lucide-react";

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentClientSlide, setCurrentClientSlide] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(1);
  const [currentHotelSlide, setCurrentHotelSlide] = useState(0);
  const [hotelsPerView, setHotelsPerView] = useState(1);
  const [isClientAutoScrolling, setIsClientAutoScrolling] = useState(true);
  const [isHotelAutoScrolling, setIsHotelAutoScrolling] = useState(true);

  const slides = [
    {
      title: "Industrial Catering Services",
      description:
        "Fresh, hygienic and delicious food for your workforce. We serve 5000+ meals daily across top corporations.",
      features: ["Tiffin Service", "Corporate Events", "Staff Canteen"],
      buttonText: "Get Catering Quote",
      button2Text: "View Services",
      buttonLink: "/contact",
      button2Link: "/services",
      icon: (
        <Utensils className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-[#E6B325]" />
      ),
      bgImage: hero1,
      bgColor: "bg-[#2F3C7E]/60",
    },
    {
      title: "Guest House Management",
      description:
        "Complete corporate accommodation solutions with housekeeping, maintenance, and 24/7 concierge services.",
      features: ["Housekeeping", "Maintenance", "Reception", "Security"],
      buttonText: "Book a Stay",
      button2Text: "View Properties",
      buttonLink: "/contact",
      button2Link: "/gallery",
      icon: (
        <Home className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-[#E6B325]" />
      ),
      bgImage: hero2,
      bgColor: "bg-[#2F3C7E]/60",
    },
    {
      title: "Housekeeping & Laundry",
      description:
        "Professional cleaning and linen services for offices, hotels, and institutions with eco-friendly products.",
      features: [
        "Deep Cleaning",
        "Linen Service",
        "Disinfection",
        "Waste Management",
      ],
      buttonText: "Get Quote",
      button2Text: "Our Clients",
      buttonLink: "/contact",
      button2Link: "/clients",
      icon: (
        <Sparkles className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-[#E6B325]" />
      ),
      bgImage: hero3,
      bgColor: "bg-[#2F3C7E]/60",
    },
  ];

  const hotels = [
    { name: "Krishna Restaurant", location: "Valsad" },
    { name: "Holiday Inn — Guest House", location: "Mehsana" },
    { name: "Vaibhav Hotel & Guest House", location: "Ahmedabad" },
    { name: "Rajwadi Hotel", location: "Udwada" },
    { name: "Ashapura Punjabi Restaurant", location: "Bhuj" },
    { name: "Ashapura Jain Gujarati Thali", location: "Bhuj" },
    { name: "Payal Restaurant", location: "Bhuj" },
    { name: "Rangoli Hotel", location: "Mundra Port" },
   
  ];

  const clients = [
    { name: "Suzlon Energy Ltd.", location: "Khopadva", category: "Industrial" },
    { name: "GHCL Limited", location: "Bhilad", category: "Industrial" },
    { name: "Waaree Energies Ltd.", location: "Tumb", category: "Industrial" },
    { name: "Waaree Energies Ltd.", location: "Nandigram", category: "Industrial" },
    { name: "Waaree Energies Ltd.", location: "Unn Navsari", category: "Industrial" },
    { name: "Waaree Energies Ltd.", location: "Shyamkhyali", category: "Industrial" },
    { name: "Captech Private Ltd.", location: "Umargaon", category: "Industrial" },
    { name: "CMP Machinery & Plastic", location: "Umargaon", category: "Industrial" },
    { name: "Adani", location: "Mundra Port", category: "Industrial" },
    { name: "Adani", location: "Khavda-Kutch", category: "Industrial" },
    { name: "Krishna Restaurant", location: "Valsad", category: "Restaurant" },
    { name: "Holiday Inn — Guest House", location: "Mehsana", category: "Hotel" },
    { name: "Vaibhav Hotel & Guest House", location: "Ahmedabad", category: "Hotel" },
    { name: "Rajwadi Hotel", location: "Udwada", category: "Hotel" },
    { name: "Ashapura Punjabi Restaurant", location: "Bhuj", category: "Restaurant" },
    { name: "Ashapura Jain Gujarati Thali", location: "Bhuj", category: "Restaurant" },
    { name: "Payal Restaurant", location: "Bhuj", category: "Restaurant" },
    { name: "Rangoli Hotel", location: "Mundra Port", category: "Hotel" },
    { name: "Shree Swaminarayan School", location: "Bhuj", category: "School" },
    { name: "White House Public School", location: "Bhuj", category: "School" },
    { name: "Army School", location: "Bhuj", category: "School" },
    { name: "Chanakya School", location: "Bhuj", category: "School" },
    { name: "Shree Swaminarayan Hospital", location: "Bhuj", category: "Hospital" },
    { name: "G.K. General Hospital", location: "Bhuj", category: "Hospital" },
    { name: "Shalby Hospital", location: "Ahmedabad", category: "Hospital" },
    { name: "Zydus Hospital", location: "Ahmedabad", category: "Hospital" },
    { name: "Geetanjali Hospital", location: "Udaipur", category: "Hospital" },
    { name: "Yaksh Mandir", location: "Jain Institution", category: "Temple" },
    { name: "Shree Swaminarayan Temple", location: "Bhuj", category: "Temple" },
    { name: "Navneet", location: "Jain Community Group", category: "Institutional" },
    { name: "Seth Dosabhai Lalchand", location: "Jain Community Group", category: "Institutional" },
    { name: "VBC Nutan Seva Sankul", location: "Jain Community Group", category: "Institutional" },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  // Update itemsPerView based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setItemsPerView(4);
        setHotelsPerView(4);
      } else if (window.innerWidth >= 640) {
        setItemsPerView(2);
        setHotelsPerView(2);
      } else {
        setItemsPerView(1);
        setHotelsPerView(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextClientSlide = () => {
    const maxIndex = clients.length - itemsPerView;
    setCurrentClientSlide((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevClientSlide = () => {
    const maxIndex = clients.length - itemsPerView;
    setCurrentClientSlide((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const nextHotelSlide = () => {
    const maxIndex = hotels.length - hotelsPerView;
    setCurrentHotelSlide((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevHotelSlide = () => {
    const maxIndex = hotels.length - hotelsPerView;
    setCurrentHotelSlide((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  // Auto-scroll for Clients section
  useEffect(() => {
    if (!isClientAutoScrolling) return;
    const interval = setInterval(() => {
      const maxIndex = clients.length - itemsPerView;
      setCurrentClientSlide((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [itemsPerView, clients.length, isClientAutoScrolling]);

  // Auto-scroll for Hotels section
  useEffect(() => {
    if (!isHotelAutoScrolling) return;
    const interval = setInterval(() => {
      const maxIndex = hotels.length - hotelsPerView;
      setCurrentHotelSlide((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [hotelsPerView, hotels.length, isHotelAutoScrolling]);

  return (
    <Layout>
      {/* ===== HERO SECTION WITH SLIDER ===== */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[85vh] overflow-hidden">
        <div className="relative h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-500 ease-in-out
                ${index === currentSlide ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            >
              {/* Background Image with Overlay */}
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.bgImage})` }}
              >
                <div className={`absolute inset-0 ${slide.bgColor}`}></div>
              </div>

              {/* Decorative Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-0 w-48 sm:w-64 md:w-96 h-48 sm:h-64 md:h-96 bg-[#E6B325] rounded-full filter blur-3xl"></div>
                <div className="absolute bottom-0 right-0 w-48 sm:w-64 md:w-96 h-48 sm:h-64 md:h-96 bg-[#E6B325] rounded-full filter blur-3xl"></div>
              </div>

              {/* Slide Content */}
              <div className="relative h-full flex items-center justify-center px-4">
                <div className="container mx-auto px-4">
                  <div className="max-w-3xl mx-auto text-center text-white">
                    {/* Icon */}
                    <div className="flex justify-center mb-3 sm:mb-4 md:mb-6">
                      {slide.icon}
                    </div>

                    {/* Title */}
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-2 sm:mb-3 md:mb-4 px-2">
                      {slide.title}
                    </h1>

                    {/* Description */}
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 mb-4 sm:mb-6 md:mb-8 max-w-2xl mx-auto px-4">
                      {slide.description}
                    </p>

                    {/* Features */}
                    <div className="flex flex-wrap gap-1 sm:gap-2 md:gap-3 justify-center mb-4 sm:mb-6 md:mb-8 px-2">
                      {slide.features.map((feature, i) => (
                        <span
                          key={i}
                          className="bg-white/20 backdrop-blur-sm px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full text-xs sm:text-sm"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 justify-center px-4">
                      <Link to={slide.buttonLink} className="w-full sm:w-auto">
                        <button className="w-full sm:w-auto bg-[#E6B325] text-[#2F3C7E] px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 rounded-lg font-semibold hover:bg-[#c99a1a] transition shadow-lg text-xs sm:text-sm md:text-base">
                          {slide.buttonText}
                        </button>
                      </Link>
                      <Link to={slide.button2Link} className="w-full sm:w-auto">
                        <button className="w-full sm:w-auto border-2 border-white bg-white/10 backdrop-blur-sm text-white px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 rounded-lg font-semibold hover:bg-white hover:text-[#2F3C7E] transition shadow-lg text-xs sm:text-sm md:text-base">
                          {slide.button2Text}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          onClick={prevSlide}
          className="absolute left-2 sm:left-3 md:left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-1.5 sm:p-2 md:p-3 rounded-full backdrop-blur-sm transition z-10"
        >
          <ChevronLeft size={16} className="sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 sm:right-3 md:right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-1.5 sm:p-2 md:p-3 rounded-full backdrop-blur-sm transition z-10"
        >
          <ChevronRight size={16} className="sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-3 sm:bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-1 sm:gap-1.5 md:gap-2 z-10">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-1 sm:h-1.5 md:h-2 rounded-full transition-all ${
                index === currentSlide
                  ? "w-4 sm:w-6 md:w-8 bg-[#E6B325]"
                  : "w-1 sm:w-1.5 md:w-2 bg-white/50 hover:bg-white/80"
              }`}
            />
          ))}
        </div>
      </section>

      {/* ===== ABOUT SECTION ===== */}
      <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-12 mb-10 sm:mb-12 md:mb-14 lg:mb-16">
            <div className="text-center lg:text-center">
              <div className="mb-4 sm:mb-6 md:mb-8">
                <div className="flex justify-center lg:justify-center mb-2 sm:mb-3 md:mb-4">
                  <HeartHandshake className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 text-[#E6B325]" />
                </div>
                <span className="text-xs sm:text-sm md:text-base font-semibold text-[#2F3C7E] uppercase tracking-wider block mb-1 sm:mb-2">
                  Welcome to
                </span>
                <div>
                  <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#2F3C7E] block leading-tight">
                    Shiv Shakti
                  </span>
                  <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#E6B325] block">
                    Hospitality
                  </span>
                </div>
              </div>
            </div>

            <div className="text-center lg:text-left">
              <span className="text-base sm:text-lg md:text-xl font-medium text-gray-900 block mb-2 sm:mb-3 md:mb-4">
                "Excellence, Timeliness, and Cleanliness"
              </span>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-5 md:mb-6">
                Shiv Shakti Hospitality is a leading provider of comprehensive
                facility services, catering to corporate offices, educational
                institutions, and healthcare organizations. Our mission is to
                deliver wholesome meals alongside outstanding service across the
                nation. We take pride in our dedication to quality, innovation,
                and strict hygiene standards, establishing ourselves as trusted
                industry leaders. Our expertise also includes managing guest
                accommodations, professional housekeeping, and diverse culinary
                operations.
              </p>
              <Link to="/about">
                <button className="bg-[#2F3C7E] text-white px-5 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 rounded-lg font-semibold hover:bg-[#1E2A5A] transition text-xs sm:text-sm md:text-base">
                  About Us
                </button>
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <img src={hero1} alt="Industrial Catering" className="w-full h-36 sm:h-40 md:h-44 lg:h-48 object-cover" />
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#2F3C7E] mb-2 sm:mb-3">
                  Industrial Dining Solutions
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                  Customized dining solutions for industrial and corporate clients,
                  focusing on hygiene, premium quality, and delightful taste in every meal.
                </p>
                <div className="h-px bg-gray-200 my-3 sm:my-4"></div>
                <Link to="/services" className="text-xs sm:text-sm font-semibold text-gray-800 uppercase tracking-wider flex justify-between items-center">
                  More Info
                  <span className="text-base sm:text-lg">→</span>
                </Link>
              </div>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <img src={hero2} alt="Corporate Guest House Management" className="w-full h-36 sm:h-40 md:h-44 lg:h-48 object-cover" />
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#2F3C7E] mb-2 sm:mb-3">
                  Corporate Stay Management
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                  Well-maintained, welcoming spaces that reflect your brand —
                  with end-to-end care from housekeeping to facility management
                  for a seamless guest experience.
                </p>
                <div className="h-px bg-gray-200 my-3 sm:my-4"></div>
                <Link to="/services" className="text-xs sm:text-sm font-semibold text-gray-800 uppercase tracking-wider flex justify-between items-center">
                  More Info
                  <span className="text-base sm:text-lg">→</span>
                </Link>
              </div>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden sm:col-span-2 lg:col-span-1">
              <img src={hero3} alt="Housekeeping & Laundry Services" className="w-full h-36 sm:h-40 md:h-44 lg:h-48 object-cover" />
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#2F3C7E] mb-2 sm:mb-3">
                  Professional Housekeeping & Laundry
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                  Trained professionals delivering efficient cleaning and
                  laundry solutions to maintain hygienic, organized, and
                  productive workspaces for your organization.
                </p>
                <div className="h-px bg-gray-200 my-3 sm:my-4"></div>
                <Link to="/services" className="text-xs sm:text-sm font-semibold text-gray-800 uppercase tracking-wider flex justify-between items-center">
                  More Info
                  <span className="text-base sm:text-lg">→</span>
                </Link>
              </div>
            </div>
          </div>

          <div className="text-center mt-8 sm:mt-10 md:mt-12">
            <Link to="/services">
              <button className="bg-[#2F3C7E] text-white px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-4 rounded-lg font-semibold hover:bg-[#1E2A5A] transition text-sm sm:text-base md:text-lg">
                Explore Our Services
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* ===== REASONS TO STAY WITH US ===== */}
      <section className="position-relative overflow-visible py-0">
        <div className="container-fluid px-0">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2 h-[250px] sm:h-[300px] md:h-[400px] lg:h-[500px] xl:h-[600px] bg-cover bg-center"
              style={{ backgroundImage: `url(${stay})` }}
            ></div>

            <div className="w-full lg:w-1/2 bg-[#2F3C7E] py-10 sm:py-12 md:py-16 lg:py-20 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24">
              <span className="text-xs sm:text-sm font-semibold text-[#E6B325] uppercase tracking-wider block mb-3 sm:mb-4 md:mb-5">
                Reasons to stay with us
              </span>
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4 sm:mb-5 md:mb-6">
                Why Choose Shiv Shakti?
              </h5>
              <p className="text-sm sm:text-base text-white/90 mb-6 sm:mb-7 md:mb-8 leading-relaxed">
                Shiv Shakti Hospitality adds value by delivering high-quality food and services at competitive prices, 
                maintaining strict hygiene and safety standards. Backed by a dedicated and experienced management team, 
                we ensure excellence in every aspect of hospitality.
              </p>
              
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex gap-3 sm:gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 bg-[#E6B325] rounded-full flex items-center justify-center">
                      <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4 text-[#2F3C7E]" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <span className="text-sm sm:text-base text-white block">
                      To focus on the core competence of your business while we handle your hospitality needs
                    </span>
                  </div>
                </li>
                <li className="flex gap-3 sm:gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 bg-[#E6B325] rounded-full flex items-center justify-center">
                      <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4 text-[#2F3C7E]" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <span className="text-sm sm:text-base text-white block">
                      To deliver the best quality and exceptional value for your investment
                    </span>
                  </div>
                </li>
                <li className="flex gap-3 sm:gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 bg-[#E6B325] rounded-full flex items-center justify-center">
                      <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4 text-[#2F3C7E]" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <span className="text-sm sm:text-base text-white block">
                      To benefit from a management team with excellent human relations skills and industry expertise
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS SECTION ===== */}
      <section className="bg-blue-50 overflow-visible py-10 sm:py-12 md:py-14 lg:py-16">
        <div className="container mx-auto px-4">
          <div className="flex justify-center text-center mb-8 sm:mb-10 md:mb-12">
            <div className="w-full max-w-lg px-4">
              <span className="text-xs sm:text-sm font-semibold text-[#E6B325] uppercase tracking-wider block mb-1 sm:mb-2">
                Exclusive rating
              </span>
              <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E]">
                What customer say
              </h5>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-12 max-w-6xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Rajesh Mehta</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                The quality of food and hygiene practices are outstanding. Our employees eagerly await 
                their meals—fresh, flavorful, and consistently delivered on time. A reliable hospitality partner!
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Priya Deshmukh</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                We've partnered with them for facility management services for over three years. 
                Their consistency and keen attention to detail truly distinguish them from others in the industry.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Suresh Patil</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                Their guest house services showcase true professionalism. From upkeep to guest management, 
                everything runs smoothly and efficiently. A great experience with Shiv Shakti!
              </p>
            </div>

             <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Narayan Singh</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                I am thoroughly delighted with the services offered by Shivshakti Hospitality. The staff's attention to detail and 
                warm hospitality is truly commendable. The food quality is excellent, and the presentation is top-notch. I appreciate 
                the way they cater to specific dietary requirements and preferences. Shivshakti Hospitality is a great choice for 
                industrial canteen services, and I highly recommend them for their professionalism and commitment to excellence.😊
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Naresh Jain</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                Excellent service and food quality. Highly recommend Shivshakti Hospitality for industrial canteen needs. Their staff's 
                professionalism and attention to detail are truly impressive. Overall, a reliable partner for quality catering services.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Nilesh Rajput</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                Their hospitality is truly praiseworthy, they serve with an open heart. Their prices are very reasonable and 
                budget-friendly, much lower than market rates, and the service they provide at such a budget is unbelievable.
              </p>
            </div>


          <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Mahenra Kumawat</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
               Such excellent service at such low prices, I don't think any other hospitality provider can match. The owner is very 
               knowledgeable, Jaspal Singh has professional expertise in every minor aspect of hospitality. I suggest you give them the work to take care of your company employees' food and hospitality without worry, hand it over to them freely. I give 5 stars.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Sunil Joshi</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                They have been serving in our school for 8 years, and I haven't seen a single mistake or any misbehavior. Very appreciable hospitality company.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition p-5 sm:p-6 md:p-7 lg:p-8">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <div className="flex gap-0.5 sm:gap-1 mb-2 sm:mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#E6B325] fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <div className="text-base sm:text-lg font-semibold text-gray-800">Surendra Pal</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
               They serve from the heart, they feed food with pure love. Their work destination feels like home while dining in the 
               cafeteria, thanks to their behavior and form of service.
              </p>
            </div>



          </div>
        </div>
      </section>

      {/* ===== CLIENTS CAROUSEL SECTION ===== */}
      <section className="py-10 sm:py-12 md:py-14 lg:py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-center text-center mb-6 sm:mb-8 md:mb-10 lg:mb-12">
            <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E]">
              Our Clients
            </h5>
          </div>

          <div 
            className="relative px-8 sm:px-10 md:px-14 lg:px-20 xl:px-24"
            onMouseEnter={() => setIsClientAutoScrolling(false)}
            onMouseLeave={() => setIsClientAutoScrolling(true)}
          >
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentClientSlide * (100 / itemsPerView)}%)`,
                }}
              >
                {clients.map((client, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 px-3 sm:px-2"
                    style={{ width: `${100 / itemsPerView}%` }}
                  >
                    <div className="flex flex-col items-center justify-center py-4 sm:py-6 bg-white rounded-xl shadow-md hover:shadow-lg transition border border-gray-100 mx-1 sm:mx-0">
                      <div className="bg-[#E6B325]/10 p-3 sm:p-4 rounded-full mb-2 sm:mb-3">
                        {client.category === "Industrial" && <Building2 className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "Restaurant" && <Utensils className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "Hotel" && <Hotel className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "School" && <School className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "Hospital" && <Heart className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "Temple" && <Landmark className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                        {client.category === "Institutional" && <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#2F3C7E]" />}
                      </div>
                      <h6 className="text-sm sm:text-base font-semibold text-gray-800 text-center px-2">
                        {client.name}
                      </h6>
                      <p className="text-xs text-gray-500 text-center mt-1 px-2">
                        {client.location}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={prevClientSlide}
              className="absolute left-2 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-1.5 sm:p-2 md:p-3 shadow-lg hover:shadow-xl transition z-10"
            >
              <ChevronLeft className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-[#2F3C7E]" />
            </button>
            <button
              onClick={nextClientSlide}
              className="absolute right-2 sm:-right-2 md:-right-3 lg:-right-4 xl:-right-6 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-1.5 sm:p-2 md:p-3 shadow-lg hover:shadow-xl transition z-10"
            >
              <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-[#2F3C7E]" />
            </button>

            <div className="flex justify-center gap-2 mt-6 lg:hidden">
              {Array.from({
                length: Math.ceil(clients.length / itemsPerView),
              }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentClientSlide(index * itemsPerView)}
                  className={`h-1.5 sm:h-2 rounded-full transition-all ${
                    Math.floor(currentClientSlide / itemsPerView) === index
                      ? "w-4 sm:w-6 bg-[#E6B325]"
                      : "w-1.5 sm:w-2 bg-gray-300 hover:bg-gray-400"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ===== OUR HOTELS SECTION ===== */}
      <section className="bg-blue-50 py-10 sm:py-12 md:py-14 lg:py-16">
        <div className="container mx-auto px-4">
          <div className="flex justify-center text-center mb-6 sm:mb-8 md:mb-10 lg:mb-12">
            <h5 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2F3C7E]">
              Our Hotels
            </h5>
          </div>

          <div 
            className="relative px-6 sm:px-10 md:px-14 lg:px-20 xl:px-24"
            onMouseEnter={() => setIsHotelAutoScrolling(false)}
            onMouseLeave={() => setIsHotelAutoScrolling(true)}
          >
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentHotelSlide * (100 / hotelsPerView)}%)`,
                }}
              >
                {hotels.map((hotel, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 px-2"
                    style={{ width: `${100 / hotelsPerView}%` }}
                  >
                    <div className="flex flex-col items-center justify-center py-4">
                      <Hotel className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-[#2F3C7E] mb-2 sm:mb-3" />
                      <h6 className="text-sm sm:text-base md:text-lg font-bold text-gray-800 mb-1 text-center">
                        {hotel.name}
                      </h6>
                      <p className="text-xs sm:text-sm text-gray-600 text-center">
                        {hotel.location}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={prevHotelSlide}
              className="absolute left-0 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 sm:p-2.5 md:p-3 shadow-lg hover:shadow-xl transition z-10"
            >
              <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 text-[#2F3C7E]" />
            </button>
            <button
              onClick={nextHotelSlide}
              className="absolute right-0 sm:-right-2 md:-right-3 lg:-right-4 xl:-right-6 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 sm:p-2.5 md:p-3 shadow-lg hover:shadow-xl transition z-10"
            >
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-[#2F3C7E]" />
            </button>

            <div className="flex justify-center gap-2 mt-6 lg:hidden">
              {Array.from({
                length: Math.ceil(hotels.length / hotelsPerView),
              }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentHotelSlide(index * hotelsPerView)}
                  className={`h-2 rounded-full transition-all ${
                    Math.floor(currentHotelSlide / hotelsPerView) === index
                      ? "w-6 bg-[#E6B325]"
                      : "w-2 bg-gray-300 hover:bg-gray-400"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <CTASection />
    </Layout>
  );
};

export default HomePage;